import { calcResize } from 'components/Layout/styles';
import { Col, Container, Row } from 'react-bootstrap';
import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import { mediaBreakpointDown } from 'utils/styledCssHelpers';
import { Link } from 'gatsby';
export const SSectionBG = styled.section`
  background-color: ${props => props.theme.colors.light_grey};
`;
export const SPostContainer = styled(Container)`
  padding-top: 5rem;

  .call-to-action-container {
    display: flex;
    width: 100%;
    justify-content: center;
    padding: 2rem;
    margin: 0 1rem;

    button {
      outline: none;
      border: 0;
      width: 180px;
      min-height: 45px;
      border-radius: 8px;
      color: #ffffff;
      background: ${props => props.theme.colors.primary};
      box-shadow: ${props => props.theme.shadow};

      &:hover {
        color: ${props => props.theme.colors.primary};
        background: #ffffff;
        border: 2px solid ${props => props.theme.colors.primary};
      }
    }
  }
`;
export const SPostMast = styled(Col)``;
export const SPostTitle = styled.h1`
  color: #000;
  font-size: ${calcResize(20, 40)};
`;
export const SPostDate = styled.div`
  color: #000;
`;
export const SPostInfoItem = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  color: ${props => props.theme.colors.dark_grey};
  font-size: 13px;
  svg {
    margin-right: 10px;
  }
`;
export const SPostSocials = styled.div`
  margin: 1rem 0 0.5rem;
  span {
    margin-right: 1rem;

    &::last-of-type {
      margin-right: 0;
    }
  }
`;

export const SPostContent = styled.article`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 25px;
  }
  h1 {
    margin-bottom: 40px;
  }
  h2 {
    margin-bottom: 25px;
  }

  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 15px;
  }
  [id^='buzzsprout-player'] {
    margin-bottom: 35px;
  }
`;

export const SPostFeaturedImage = styled(GatsbyImage)`
  height: ${props => (props.isPodcast ? '250px !important' : '400px')};
  width: 100%;
  border-radius: 0px;
  ${mediaBreakpointDown(
    'md',
    `
  height: 200px;
  `,
  )}
`;

export const SPostAside = styled.aside`
  margin-bottom: 1rem;

  ul {
    li {
      margin-bottom: 2rem;
    }
  }
`;

export const SPostAsideTitle = styled.h3`
  color: ${props => props.theme.colors.primary};
  text-align: center;
  font-weight: 400;
  text-decoration: underline;
  font-size: ${small => (small ? '28px' : '35px')};
`;

export const SPostTags = styled.section`
  border-top: 1px solid ${props => props.theme.colors.grey};
  padding-top: 50px;
  padding-bottom: 50px;
`;

export const SPostTag = styled(Link)`
  background-color: ${props => props.theme.colors.grey};
  color: ${props => props.theme.colors.tangaroa};
  margin-right: 10px;
  padding: 10px;
  font-weight: 300;
  border-radius: 5px;
  font-size: ${calcResize(12, 16)};
  :last-of-type {
    margin-right: 0;
  }
`;

export const FooterNav = styled(Col)`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  &.next-nav {
    text-align: right;
  }
  .link {
    font-size: 13px;
    color: ${props => props.theme.colors.main} !important;
  }
  .title {
    font-weight: bold;
    font-size: 16px;
    color: ${props => props.theme.colors.main};
  }
`;

export const SPostSidebarItem = styled(Col)`
  margin-bottom: 15px;
  background: #ffffff;
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
`;

export const SFooterNavs = styled(Row)`
  padding-top: 40px;
  padding-bottom: 40px;
  margin-bottom: 15px;
  border-top: 1px solid ${props => props.theme.colors.grey};
  border-bottom: 1px solid ${props => props.theme.colors.grey};
`;
